import styled, { css } from "styled-components"
import { P } from "../typography"
import { darken } from "polished"

const getFontSizeFromSize = (size, theme) => {
  switch (size) {
    case "small":
      return "0.75rem"
    default:
      return "1rem"
  }
}

const getPaddingFromSize = (size, theme) => {
  switch (size) {
    case "small":
      return "0.5rem 1rem"
    default:
      return "0.75rem 1.5rem"
  }
}

const getMinWidthFromSize = (size, theme) => {
  switch (size) {
    case "small":
      return "8rem"
    default:
      return "10rem"
  }
}

export const Container = styled.div`
  ${(props) =>
    props.show &&
    css`
      background-color: ${(props) => props.theme.colors.secondary};
    `}
  border-radius: 0.5rem 0.5rem 0 0;
  display: inline-block;
  position: relative;
  min-width: ${({ size, theme }) => getMinWidthFromSize(size, theme)};
`

export const Title = styled.div`
  background-color: white;
  color: ${(props) => props.theme.colors.secondaryAlternative || props.theme.secondary};
  border: 2px solid ${(props) => props.theme.colors.secondary};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  font-weight: bold;
  font-size: ${({ size, theme }) => getFontSizeFromSize(size, theme)};
  padding: ${({ size, theme }) => getPaddingFromSize(size, theme)};
  border-radius: 0.5rem;
  cursor: pointer;
  user-select: none;
  text-align: center;
`

export const Content = styled.div`
  background-color: ${(props) => props.theme.colors.secondary};
  display: none;
  padding: 5px 10px 8px 10px;
  border-radius: 0 0 0.5rem 0.5rem;
  width: 100%;
  box-sizing: border-box;

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}

  position: absolute;
  z-index: 5;
`

export const Option = styled(P).attrs({
  marginless: true,
  bold: true,
  variant: "secondaryReadable"
})`
  padding: 0.5rem 1.25rem;
  border-radius: 0.5rem;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.secondary)};
  }
`
